import React from "react";
// import Routers from "./Components/Routes/routes";
import Routers from "./Components/Routes/routes";
import store from "./Redux/Store/Index";
import { Provider } from "react-redux";
import ConfigSWR from "./Services/Swr";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Auth from "./Components/Auth";
import theme from "./theme";
import { createTheme, ThemeProvider } from '@mui/material/styles';

function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* <GlobalStyles /> */}
      <React.Fragment>              
        <Provider store={store}>
          <ConfigSWR>
            <ToastContainer />
            <Auth />
            <Routers />
          </ConfigSWR>
        </Provider>
      </React.Fragment>
    </ThemeProvider>
  );
}

export default App;

